const appConfig = {
  api: {
    baseUrl: String(import.meta.env.VITE_SERVICES_API_BASE_URL || ""),
  },
  app: {
    port: parseInt(import.meta.env.VITE_PORT) || 5173,
  },
};

export default appConfig;
